








import Vue from 'vue';
import { AccountDashboardMixin } from '@/mixins';
import EmailCampaignTabs from '@/email-campaign/EmailCampaignTabs.vue';
import AccountToolbar from '../AccountToolbar.vue';

export default Vue.extend({
  mixins: [AccountDashboardMixin],
  props: {
    clientId: {
      type: String,
      required: true,
    },
    tab: {
      type: String,
      default: 'campaigns',
    },
    reportId: String,
  },
  components: {
    'email-campaign-tabs': EmailCampaignTabs,
    'account-toolbar': AccountToolbar,
  },
});
